document.addEventListener("DOMContentLoaded", function() {
    const words = ["Matches Your Standards!"];
    const typedText = document.querySelector(".typed-text");
    let wordIndex = 0;
    let charIndex = 0;
    let isDeleting = false;
    const typingSpeed = 200; // typing speed
    const deletingSpeed = 100; // deleting speed
    const delayBetweenWords = 1500; // delay before next word

    function type() {
        const currentWord = words[wordIndex];
        if (!isDeleting) {
            typedText.textContent = currentWord.substring(0, charIndex + 1);
            charIndex++;
            if (charIndex === currentWord.length) {
                isDeleting = true;
                typedText.classList.add("blink");
                setTimeout(type, delayBetweenWords);
                return;
            }
        } else {
            typedText.textContent = currentWord.substring(0, charIndex - 1);
            charIndex--;
            if (charIndex === 0) {
                isDeleting = false;
                typedText.classList.remove("blink");
                wordIndex = (wordIndex + 1) % words.length; // next word
            }
        }
        setTimeout(type, isDeleting ? deletingSpeed : typingSpeed);
    }

    type();
});
